import { Flex, Paper, Text, ActionIcon, Badge, Anchor } from '@mantine/core';
import { IconArrowUpRight } from '@tabler/icons-react';
import { NavLink } from 'react-router';

type EmployeCardProps = {
  id: number;
  name: string;
  lastName: string;
  src: string;
  phone: string;
  isActive: boolean;
  vacancies?: number;
};

export const EmployeCard = ({
  id,
  name,
  lastName,
  src: _src,
  phone,
  isActive,
  vacancies,
}: EmployeCardProps) => {
  return (
    <Paper p={16} radius={12} bg='primary.0' w='100%'>
      <Flex direction='column' gap={24}>
        <Flex gap={8} align='center' wrap='wrap'>
          <Flex gap={4} direction='column' flex={1}>
            <Text c='primary.7'>
              {name}, {lastName}
            </Text>
            <Text size='sm' c='tertiary.7'>
              {phone}
            </Text>
          </Flex>

          <ActionIcon component={NavLink} to={`/user-list/${id}`}>
            <IconArrowUpRight
              size={24}
              color='var(--mantine-color-primary-7)'
            />
          </ActionIcon>
        </Flex>

        <Flex gap={16} align='center' wrap='wrap' justify='space-between'>
          {isActive ? (
            <Badge variant='light-skill' color='green'>
              Активный
            </Badge>
          ) : (
            <Badge variant='light-skill' color='red'>
              Неактивный
            </Badge>
          )}

          {!!vacancies && (
            <Anchor
              component={NavLink}
              to={`/vacancy-list/?user.fullName=${name} ${lastName}&opened=true`}
              c='secondary.7'
              size='sm'
            >
              {`${vacancies} вакансий`}
            </Anchor>
          )}
        </Flex>
      </Flex>
    </Paper>
  );
};
